<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>PLEITOS</span>
                </h4>
                <app-tabela
                    :itens="pleitos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false">
                    <template slot="botoes">
                            <btn-inserir-pleito
                                variant="success"
                                v-if="permiteInserir"
                                :pleitosServicos="pleitosServicos"
                                :rotaListagem="rotaListagem"
                                :rotaInserir="rotaInserir">
                                Inserir Pleito
                            </btn-inserir-pleito>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <div class="flex flex-row">
                            <btn-atualizar-pleito
                                :pleito="data"
                                v-if="permiteAtualizar"
                                :pleitosServicos="pleitosServicos"
                                :rotaListagem="rotaListagem"
                                :rotaAtualizar="rotaAtualizar">
                            </btn-atualizar-pleito>
                            <span
                                class="text-danger float-left mr-1">
                                <i
                                    class="fa fa-exclamation-circle fa-lg icon-button"
                                    title="Justificativa"
                                    v-if="data.status == 1"
                                    @click.stop="mostrarJustificativa(data.justificativaReprovacaoPertinencia)"
                                ></i>
                            </span>
                            <span
                                class="text-danger float-left mr-1">
                                <i
                                    class="fa fa-exclamation-circle fa-lg icon-button"
                                    title="Justificativa"
                                    v-if="data.status == 3"
                                    @click.stop="mostrarJustificativa(data.justificativaReprovacaoConformidadeTecnica)"
                                ></i>
                            </span>
                            <span class="text-primary">
                                <i
                                    class="fa fa-info-circle fa-lg icon-button mr-1"
                                    title="Detalhar"
                                    @click.stop="detalhes(data.pleitoId)"
                                    v-if="temAcessoDetalhar"
                                ></i>
                            </span>
                            <span>
                                <btn-excluir
                                :pleito="data"
                                :servicos="pleitosServicos"
                                v-if="permiteExcluir"
                                @listarPleitos="listarPleitos()">
                                </btn-excluir>
                            </span>
                            <span>
                                <btn-aprovar-pertinencia
                                :pleito="data"
                                :servicos="pleitosServicos"
                                v-if="permiteAprovarPertinencia && data.status == 0"
                                @listarPleitos="listarPleitos()">
                                </btn-aprovar-pertinencia>
                            </span>
                            <span>
                                <btn-reprovar-pertinencia
                                :pleito="data"
                                :servicos="pleitosServicos"
                                v-if="permiteReprovarPertinencia && data.status == 0"
                                @listarPleitos="listarPleitos()">
                                </btn-reprovar-pertinencia>
                            </span>
                            <span>
                                <btn-aprovar-conformidade-tecnica
                                :pleito="data"
                                :servicos="pleitosServicos"
                                v-if="permiteAprovarReprovarConformidadeTecnica && data.status == 2"
                                @listarPleitos="listarPleitos()">
                                </btn-aprovar-conformidade-tecnica>
                            </span>
                            <span>
                                <btn-reprovar-conformidade-tecnica
                                :pleito="data"
                                :servicos="pleitosServicos"
                                v-if="permiteAprovarReprovarConformidadeTecnica && data.status == 2"
                                @listarPleitos="listarPleitos()">
                                </btn-reprovar-conformidade-tecnica>
                            </span>
                            <span>
                                <documentos-pleito
                                    :pleito="data"
                                    :servicos="pleitosServicos"
                                    @listarPleitos="listarPleitos()">
                                </documentos-pleito>
                            </span>
                            <span
                                class="text-success float-left mr-1">
                                <i
                                    v-if="permiteReenviarPleitoParaAnalise && data.status == 3"
                                    class="fa fa-upload fa-lg icon-button"
                                    title="Enviar Pleito Para nova análise"
                                    @click.stop="enviarPleitoNovaAnalise(data.pleitoId)"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template slot="statusDescricao" slot-scope="data">
                        <app-status
                            :status="data.statusDescricao.toUpperCase()"
                        ></app-status>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import BtnInserirPleito from '../componentes/BtnInserirPleito';
import BtnExcluir from '../componentes/BtnExcluir';
import BtnAprovarPertinencia from '../componentes/BtnAprovarPertinencia';
import BtnReprovarPertinencia from '../componentes/BtnReprovarPertinencia';
import BtnAtualizarPleito from '../componentes/BtnAtualizarPleito';
import DocumentosPleito from '../componentes/DocumentosPleito';
import BtnAprovarConformidadeTecnica from '../componentes/BtnAprovarConformidadeTecnica';
import BtnReprovarConformidadeTecnica from '../componentes/BtnReprovarConformidadeTecnica';


export default {
    components: {
        BtnExcluir,
        BtnAprovarPertinencia,
        BtnReprovarPertinencia,
        BtnInserirPleito,
        BtnAtualizarPleito,
        DocumentosPleito,
        BtnAprovarConformidadeTecnica,
        BtnReprovarConformidadeTecnica
    },
    props: {
        pleitosServicos: {
            type: Object,
            default: () => ({}) 
        },
        rotaDetalhar: {
            type: String
        },

        rotaListagem: {
            type: String
        },
        rotaInserir: {
            type: String
        },
        rotaAtualizar: {
            type: String
        },
        temAcessoDetalhar: {
            type: Boolean,
            default: () => false
        },
        permiteInserir: {
            type: Boolean,
            default: () => false
        },
        permiteAtualizar: {
            type: Boolean,
            default: () => false
        },
        permiteExcluir: {
            type: Boolean,
            default: () => false
        },
        permiteAprovarPertinencia: {
            type: Boolean,
            default: () => false
        },
        permiteReprovarPertinencia: {
            type: Boolean,
            default: () => false
        },
        permiteAprovarReprovarConformidadeTecnica: {
            type: Boolean,
            default: () => false
        },
        permiteReenviarPleitoParaAnalise: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            pleitos: [],
            campos: [
                {
                    key: 'numeroPleito',
                    label: 'Número',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descritivo',
                    label: 'Nome do Projeto/Pleito',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vigencia',
                    label: 'Vigência',
                    sortable: true,
                },
                {
                    key: 'nomeProponente',
                    label: 'Nome do Proponente',
                    filterable: true,
                },
                {
                    key: 'statusDescricao',
                    label: 'Status',
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        listarPleitos() {
            this.$store.dispatch('addRequest')
            this.pleitosServicos.listarPleitos().then(response => {
                if (response) {
                    if (response.success) {
                        this.pleitos = response.data;
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalhes(id){
            this.$router.push({
                name: this.rotaDetalhar,
                params: {
                    pleitoId: id
                }
            })
        },

        mostrarJustificativa(justificativa) {
            this.$swal({
                title: 'Justificativa',
                html: `<b>${justificativa}</b>`,
                icon: 'warning',
            })            
        },

        enviarPleitoNovaAnalise(pleitoId) {
            this.$store.dispatch('addRequest')
            this.pleitosServicos.enviarPleitoNovaAnalise(pleitoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.listarPleitos()
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },

    created() {
        this.listarPleitos()
    },
}
</script>
